import styled from 'styled-components';

export const ProfileHeaderNoDataWrapper = styled.div`
    display: flex;
    padding: var(--spacing-md, 24px);
    align-items: center;
    gap: 16px;
    border-radius: var(--border-radius-s_8, 8px);
    border: 1px solid var(--colors-border-primary, #e2e8f0);
    background: var(--colors-surface-primary, #fff);
    margin: 24px 0;
`;

export const User = styled.div`
    svg {
        width: 72px;
        height: 72px;
        border: 2px solid var(--colors-border-primary, #e2e8f0);
        border-radius: 50%;
        padding: 18px;
    }
`;
